import { PlayButtonStroke } from 'assets/icons';
import {
  StyledDescription,
  StyledHeading,
  StyledImage,
  StyledLabel,
  StyledVideoPlayButton,
  StyledWrapper,
} from './styles';

type ContentImageCardProps = {
  link: string;
  isVideo: boolean;
  label: string;
  title: string;
  description: string;
  state: 'not started' | 'in progress' | 'complete';
  image: string;
  imageAlt: string;
};
const ContentImageCard: React.FC<ContentImageCardProps> = ({
  link,
  isVideo,
  label,
  description,
  state,
  title,
  image,
  imageAlt,
  ...rest
}) => {
  return (
    <StyledWrapper to={link} state={state} {...rest}>
      {isVideo && (
        <StyledVideoPlayButton>
          <PlayButtonStroke color="white" />
        </StyledVideoPlayButton>
      )}
      <StyledImage src={image} alt={imageAlt} />
      <StyledLabel>{label}</StyledLabel>
      <StyledHeading>{title}</StyledHeading>
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  );
};

export default ContentImageCard;
